<script setup>
import {computed} from "vue";

const props = defineProps(['show', 'title', 'body', 'options'])
const emit = defineEmits(['clicked']);

const showModal = computed({
    get() {
        return props.show;
    },

    set(value) {
        emit('update:show', value);
    }
});

defineExpose({
    open
});
</script>

<template>
    <b-modal v-model="showModal" :title="title" modal-class="modal-w-sm">
        <p>
            {{ body }}
        </p>

        <template #modal-footer>
            <div style="display: flex; align-items: center; justify-content: space-between; width: 90%;">
                <b-button
                    v-for="option in options"
                    :key="option.value"
                    :variant="option.variant ?? 'primary'"
                    @click="emit('clicked', option.value)"
                >
                    {{ option.label }}
                </b-button>
            </div>
        </template>
    </b-modal>
</template>

<style scoped>

</style>
